import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { Page } from 'components/Page';
import { Sidebar } from './Sidebar';

export const Shipments: React.FC = () => {
  return (
    <Page>
      <div style={{ display: 'flex' }} className="w-full h-full">
        <Sidebar />
        <div className="flex-grow flex flex-col" style={{ minWidth: 0 }}>
          <Outlet />
        </div>
      </div>
    </Page>
  );
};
Shipments.displayName = 'Shipments';
